export function isEntity<T>(
  entity: string | T | null | undefined,
): entity is T {
  return typeof entity !== 'string' && entity !== undefined && entity !== null;
}

export function isStringEntity<T>(entity: string | T): entity is string {
  return typeof entity === 'string';
}

export function thousandSeparator(value: number | string): string {
  const numberValue = typeof value === 'string' ? parseFloat(value) : value;
  return numberValue.toLocaleString('es-AR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatCurrency(
  value: number | string,
  currencySymbol: string = '$',
): string {
  const numberValue = typeof value === 'string' ? parseFloat(value) : value;
  return `${currencySymbol}${thousandSeparator(numberValue)}`;
}
